import styled from 'styled-components';

const BackButton = styled.div`
    font-size: 1rem;
    background: ${props => props.theme.backBtn.bg};
    height: 3.125rem;
    line-height: 3.125rem;
    min-width: 6.25rem;
    display: inline-block;
    text-align: center;
    color: ${props => props.theme.backBtn.txt};
    margin-right: 0.625rem;
    
    @media only screen and (min-width:500px) {
        font-size: 1.125rem;
    }
`;

export default BackButton;